export default [
  'Plexis',
  'Dr. Bronners',
  'Lykos',
  'Onnit Gym',
  'Black Swan',
  'Warrior Poet',
  'Fit for Service',
  'Chakaruna Media',
  'Bridge to One',
].sort();